module.exports = __webpack_public_path__ + "static/media/hn-nam-tu-lien.1f7dc683.svg";